import { render, staticRenderFns } from "./operation-board-department-select.vue?vue&type=template&id=4ecd80a5&scoped=true&"
import script from "./operation-board-department-select.vue?vue&type=script&lang=js&"
export * from "./operation-board-department-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd80a5",
  null
  
)

export default component.exports